<!-- 一键求救页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left">
        <el-scrollbar class="scroll-bar-view">
          <el-tree
            :data="frame"
            :props="treeProps"
            class="shebeiDiv"
            @node-click="currentChange"
            :expand-on-click-node="true"
            :default-expand-all="false"
            :default-expanded-keys="['1']"
            :highlight-current="true"
            node-key="thirdDeviceId"
            ref="vuetree"
          ></el-tree>
        </el-scrollbar>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 主机设备列表 -->
        <div class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar flex-row">
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="iconfont icon-iconfontfanhui"
              @click="retBtn"
              >返回</el-button
            >
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-plus"
              v-auth="'/deviceaccess/index:addDevice'"
              @click="addDialog"
              >新增</el-button
            >
            <el-button
              type="primary"
              class="iss-operation-button"
              icon="el-icon-delete"
              v-auth="'/deviceaccess/index:deleteDevice'"
              @click="delDev"
              >批量删除</el-button
            >
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table
              ref="devTab"
              :data="deviceData"
              :option="deviceOption"
              :page="devicePage"
              @search-change="handleSearchChange"
              @search-reset="resetForm"
              @current-change="selectPage"
              @selection-change="selectionChange"
              @size-change="changeSize"
            >
              <!-- 定制操作栏按钮 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="修改"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    v-auth="'/deviceaccess/index:updateDevice'"
                    @click="update(scope.row)"
                    icon="iconfont icon-xiugai"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                  popper-class="tooltip-draw"
                >
                  <el-button
                    type="text"
                    class="iconfont icon-Detail"
                    @click="showDetail(scope.row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!-- add+update设备数据弹框  -->
    <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      v-dialogDragpx
      :visible.sync="editDevDialog"
      width="1000px"
      :center="true"
    >
      <edit-dev :key="key" ref="editDev"></edit-dev>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="diaLoading" @click="editDlgPre">{{
          diaLoading ? "保存中..." : "保 存"
        }}</el-button>
        <el-button @click="editDlgCan">{{
          diaLoading ? "保存中..." : "取 消"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../../api/index";
import { Dic, Dates } from "$utils";
import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../../config/help";
import editDev from "./touchDia";
export default {
  components: {
    editDev,
  },
  data() {
    return {
      diaLoading: false,
      key: 0,
      dialogTitle: "",
      editDevDialog: false,
      delConfirm: false,
      dialogVisible: false,
      // 存储列表数据获取方式：1、通过左侧树；2、通过搜索条件；删除时用同样的方式刷新列表数据
      getDevListType: "",
      // 选中设备ID集合
      selDev: [],
      // 查询字段
      queryForm: {
        mac: "",
        deviceName: "",
        thirdDeviceId: "",
        deviceMarkList: ["27", "28", "29"],
      },
      // 系统id
      systemId: 200000024,
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList",
      },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      cameraPage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      deviceData: [],
      cameraData: [],
      videoStreamData: [],
      deviceOption: tableOption(this),
      level: "",
      areaCode: "",
    };
  },
  created() {
    this.systemId = this.$route.query.systemId;
    this.systemName = this.$route.query.systemName;
    this.platID = this.$route.query.platID;
    this.factoryId = this.$route.query.factoryId;
    this.deviceType = this.$route.query.deviceType;
  },
  mounted() {
    // 请求树根节点
    this.getAccessDeviceInfoTree();
    // 请求设备列表
    this.getDevList();
  },
  methods: {
    // 新增/编辑保存
    editDlgPre() {
      let data = {};
      data = this.$refs.editDev.devInData;
      console.log(data);
      this.$refs.editDev.validateForm().then((valid) => {
        if (valid) {
          let params = {
            buildingCode: data.isIndoor != 1 ? "" : data.buildingCode, //所属楼栋
            abscissa: data.isIndoor != 1 ? "" : data.abscissa,
            ordinate: data.isIndoor != 1 ? "" : data.ordinate,
            height: data.isIndoor != 1 ? "" : data.height,
            width: data.isIndoor != 1 ? "" : data.width,
            isIndoor: data.isIndoor,
            latitude: data.isIndoor != 1 ? data.latitude : "",
            longitude: data.isIndoor != 1 ? data.longitude : "",
            status: data.status, //设备状态
            systemId: this.systemId,
            thirdDeviceId: data.thirdDeviceId, //设备第三方id
            thirdDeviceName: data.thirdDeviceName, //设备名称
            thirdDeviceDesc: data.thirdDeviceDesc, //设备描述
            // 自定义数据
            deviceExtendInfoMap: {
              zAlarmTime: data.zAlarmTime,
              zBattery: data.zBattery,
              zBusinessName: data.zBusinessName,
              zDeviceType: data.zDeviceType,
              zFmeter: data.zFmeter,
              zGVersion: data.zGVersion,
              zGrade: data.zGrade,
              zHeartTime: data.zHeartTime,
              zIDinteger: data.zIDinteger,
              zJmeter: data.zJmeter,
              zLinkNum: data.zLinkNum,
              zLinkTime: data.zLinkTime,
              zRange: data.zRange,
              zSVersion: data.zSVersion,
              zSetHeartTime: data.zSetHeartTime,
              zSetLinkNum: data.zSetLinkNum,
              zSetLinkTime: data.zSetLinkTime,
              zSetStress: data.zSetStress,
              zSetTime: data.zSetTime,
              zSmeter: data.zSmeter,
              zSnr: data.zSnr,
              zStates: data.zStates,
            },
          };
          console.log(params);
          let url = "";
          if (this.dialogTitle == "新增设备") {
            params.parentDeviceId = "200000011";
            params.parentDeviceIds = "-1,200000011";
            url = api.device.addSosDevice;
          } else {
            url = api.device.updateSosDevice;
            params.deviceID = data.deviceID;
          }
          this.diaLoading = true;
          this.$fetch(url, params).then((res) => {
            setTimeout(() => {
              this.diaLoading = false;
            }, 500);
            if (res.success) {
              this.$message.success(res.msgContent);
              this.editDevDialog = false;
              this.getDevList();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑框取消按钮
    editDlgCan() {
      // this.$refs.editDev.devInData.resolutionWide = '';
      // this.$refs.editDev.devInData.resolutionHigh = '';
      this.editDevDialog = false;
    },
    // 返回按钮
    retBtn() {
      this.$router.go(-1);
    },
    // 树的子节点点击事件
    currentChange(data, node) {
      this.$log.info("树的子节点点击", data);
      this.isTopTreeNode = data.areaCode !== "-1" ? false : true;
      // let parentNode = this.$refs.vuetree.getNode(data.parentCode)
      this.areaCode = data.areaCode;
      this.treeKey = data.deviceID;
      this.level = node.level;
      if (this.level) {
        this.deviceId = data.deviceID;
      }
      this.getDevList();
    },
    // 获取left tree
    getAccessDeviceInfoTree() {
      const params = {
        systemId: this.systemId,
      };
      this.$fetch(api.device.queryPlatSystemDeviceTree, params).then((res) => {
        if (res.success) {
          this.frame = [res.returnObj];
          this.$nextTick(() => {
            this.$refs.vuetree.setCurrentKey("-1");
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    // 请求数据列表数据
    requestList() {
      console.log(this.queryForm);
      const param = Object.assign(this.queryForm, {
        pageSize: this.devicePage.pageSize,
        pageNum: this.devicePage.currentPage,
        systemId: this.systemId,
      });
      this.$fetch(api.device.querySosDevice, param).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 根据查询条件查询列表
    queryDev() {
      this.devicePage.currentPage = 1;
      this.getDevListType = 1;
      this.requestList();
    },
    // 根据树查询设备列表
    getDevList() {
      this.devicePage.currentPage = 1;
      this.getDevListType = 2;
      this.requestList();
    },

    // 批量删除设备
    delDev() {
      if (this.selDev.length === 0) {
        this.$message.warning(this.$t("deviceAccess.message.deltips"));

        return;
      }
      this.delConfirm = true;
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.deletePlatDevice();
      });
    },
    // 单独删除设备
    delDevBtn(row) {
      this.selDev = [row.deviceID];
      this.$confirm(
        this.$t("deviceAccess.message.uninstall"),
        this.$t("deviceAccess.title.uninstall"),
        {
          confirmButtonText: this.$t("deviceAccess.button.confirm"),
          cancelButtonText: this.$t("deviceAccess.button.cancel"),
          type: "warning",
        }
      ).then(() => {
        this.deletePlatDevice(row);
      });
    },
    // 确认删除
    deletePlatDevice(row) {
      this.devicePage.currentPage = 1;
      this.delConfirm = false;
      let params = { deviceIDList: this.selDev };
      this.$fetch(api.device.deleteFireDevice, params).then((res) => {
        if (res.success) {
          if (this.getDevListType == 1) {
            this.queryDev();
          } else if (this.getDevListType == 2) {
            this.getDevList();
          }
          this.$message.success(this.$t("deviceAccess.message.delsuccess"));
        } else {
          this.$message.error(res.msgContent);
        }
        this.$refs.devTab.selectClear();
      });
    },
    // 取消删除
    dlgNo() {
      this.delConfirm = false;
    },
    //查看详情
    showDetail(row) {
      console.log(row);
      this.$refs.devTab.rowView(row);
    },
    // 重置搜索
    resetForm() {
      this.devicePage.pageSize = utils.Cache.get("CURRENT_PAGESIZE") || 10;
      this.devicePage.pageNo = 1;
      this.queryForm = {
        mac: "",
        deviceName: "",
        thirdDeviceId: "",
        deviceMarkList: ["27", "28", "29"],
      };
      this.getAccessDeviceInfoTree();
      // 请求设备列表
      this.getDevListType = 2;
      this.treeKey = "";
      this.requestList();
      this.devicePage.currentPage = 1;
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.devicePage.currentPage = val;
      if (this.getDevListType == 1) {
        this.getDevListType = 1;
        this.requestList();
      } else if (this.getDevListType == 2) {
        this.getDevListType = 2;
        this.requestList();
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = val;
      if (this.getDevListType == 1) {
        this.queryDev();
      } else if (this.getDevListType == 2) {
        this.getDevList();
      }
    },
    // 新增按钮
    addDialog() {
      this.editDevDialog = true;
      this.dialogTitle = "新增设备";
      this.$nextTick(() => {
        this.key += 1;
        // this.$refs.editDev.devInData.isIndoor = '1'
      });
    },
    // 编辑按钮
    update(row) {
      console.log(row);
      this.rowInfo = { ...row };
      this.editDevDialog = true;
      this.dialogTitle = "编辑设备";
      this.$nextTick(() => {
        this.$refs.editDev.devInData = Object.assign(
          row,
          row.deviceExtendInfoMap
        );
        // this.$refs.editDev.devInData.isIndoor = parseInt(row.isIndoor)
        this.$refs.editDev.selectChange(row.isIndoor);
        // console.log(this.$refs.editDev.devInData)
      });
    },
    handleSearchChange(param) {
      console.log("param", param);
      this.queryForm = param;
      this.devicePage.currentPage = 1;
      this.requestList();
    },
  },
};
</script>
<style lang="scss" scoped>
.vcnDeviceList {
  width: 100%;
  height: 100%;
  .section-main__warp {
    margin: 0 !important;
  }
  .upload-demo {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }
  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .nvr-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        display: flex;
        .tree-label {
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .area-operator {
          display: inline-block;
          margin-left: 10px;
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
  .scroll-bar-view {
    // @include set_theme_color(background-color, top-menu-bg-color);
    height: calc(100% - 0px);
    .el-scrollbar__wrap {
      // height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
}
.el-select {
  width: 100%;
}
</style>
